import {
  Box,
  BoxProps,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { useUser } from '../../../../../../../../../hooks/user';
import { MemberBookingTable } from '../../../../../../components/MemberBookingTable';
import { MemberDependantTable } from './components/MemberDependantTable';
import { MemberGuestTable } from './components/MemberGuestTable';
import Wallet from './components/Wallet';

export const MemberDetailsTabs = (props: BoxProps): JSX.Element => {
  const [tabIndex, setTabIndex] = useState(0);

  const { user: member } = useUser();

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <Box {...props}>
      <Tabs
        index={tabIndex}
        isLazy
        onChange={handleTabChanges}
        variant="enclosed-colored"
      >
        <TabList>
          <Tab>Bookings</Tab>

          {member?.featureGroup?.key === 'MEMBER' && <Tab>Dependentes</Tab>}

          <Tab>Convidados</Tab>

          <Tab>Carteira</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <MemberBookingTable />
          </TabPanel>

          {member?.featureGroup?.key === 'MEMBER' && (
            <TabPanel>
              <MemberDependantTable />
            </TabPanel>
          )}

          <TabPanel>
            <MemberGuestTable />
          </TabPanel>

          <TabPanel>
            <Wallet />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
